export default {
  // alert message
  Alert: 0,

  // confirm yes_no
  Confirm: 1,

  // // confirm info/warning
  // Alert: 0,

  // // confirm yes_no
  // Confirm: 1,

  // // confirm yes_no_cancel
  // ConfirmOrCancel: 2,

  // // confirm delete
  // ConfirmDelete: 3,

  // // confirm Đóng
  // ConfirmClose: 4,

  // confirm_Validate: 5,

  // confirm_Validate_Custom: 6,

  // // confim không hiện lại
  // ConfirmNotShowAgain: 7,
}
